import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {Layers, RockBottomLayers} from "./RockBottomLayers";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SpinePlayer} from "../../core/utils/SpinePlayer";
import {gsap, Linear} from "gsap";
import {RockBottomGameConfig} from "../RockBottomGameConfig";
import {RockBottomPickButton} from "./RockBottomPickButton";
import {DisplayObject} from "pixi.js";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {RockBottom} from "../RockBottom";
import {RockBottomGameAssets} from "../RockBottomGameAssets";
import {RockBottomSound} from "../sound/RockBottomSound";
import {RockBottomGameMode} from "../server/RockBottomGameMode";
import {IRockBottomGameData} from "../server/data/IRockBottomData";

export class RBSoftWinCapView extends PIXI.Container {
    private _pickCallback: ((index: number) => void) | undefined;
    private _layer: StageLayer | undefined;
    private _overlay: PIXI.Graphics;
    private _down_overlay: PIXI.Graphics;
    private _pickIntroSpine: SpinePlayer;
    private _pickAndClickSpine: SpinePlayer;
    private _multSeqArray: number[];
    private _multipliers: PIXI.BitmapText[] = [];
    private _multPostfixStr: string = "x";
    private _seqMap: number[][] = [
        [3, 0, 1, 2],
        [2, 1, 0, 3],
        [1, 3, 2, 0],
        [2, 0, 1, 3],
        [3, 1, 0, 2],
        [1, 0, 2, 3],
        [0, 3, 1, 2],
        [1, 2, 0, 3],
        [2, 3, 1, 0],
        [3, 2, 0, 1]
    ];

    constructor() {
        super();
        this.init();
        this.onResize();
    }

    public showView(pickCallback: (index: number) => void, freeSpinsLeft: number, isReplay: boolean): gsap.core.Timeline {
        RockBottom.keypadPlugin.setZeroBetSpinCounter(-1);
        this._pickCallback = pickCallback;

        const tl: gsap.core.Timeline = gsap.timeline();

        this._pickIntroSpine.alpha = 1;
        this._pickIntroSpine.scale.set(1);
        this._pickIntroSpine.visible = true;
        this._pickAndClickSpine.alpha = 0;
        this._pickIntroSpine.visible = false;
        RockBottomSound.fadeMusic(0, 0.1);

        if (RockBottom.model.isRestore && (RockBottom.model.parsedInitData.mode === RockBottomGameMode.FREESPIN || RockBottom.model.parsedInitData.mode === RockBottomGameMode.SUPER_FREESPIN)) {
            RockBottom.freespinOutro.setReelsOnBonusGameEnd();
        }

        tl.add([
            this.toggleVisibility(true),
            this._pickIntroSpine.play({
                name: "animation",
                onStart: () => {
                    this._down_overlay.visible = true,
                        this._down_overlay.alpha = 1;
                }
            })
        ])
        ;
        RockBottomSound.soundPlayer.playTrack({name: RockBottomSound.SOFT_WIN_CAP_DOOR_SCENE});
        tl.add(this.zoomInEffect());

        tl.add([
            () => {
                this._pickIntroSpine.visible = true;
            },
            this._pickAndClickSpine.play({
                name: "Hover",
                loop: true
            }),
            gsap.to(this._pickAndClickSpine, 0.3, {alpha: 1}),
            () => {
                if (!isReplay) {
                    this.enablePickButtons(true);
                }
            }
        ]);

        tl.add(() => {
            RockBottomSound.soundPlayer.playTrack({
                name: RockBottomSound.SOFT_WIN_CAP_PICK_CLICK,
                repeat: Number.MAX_VALUE
            });
            RockBottomSound.soundPlayer.playTrack({
                name: RockBottomSound.WIN_CAP_HOVER_LOOP,
                repeat: Number.MAX_VALUE
            });
        });

        return tl;
    }

    public hideView(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.to(this._pickAndClickSpine, 0.3, {
            alpha: 0,
            onStart: () => {
                this.initMultSeqArray();
            },
            onComplete: () => {
                this._pickAndClickSpine.stop();
                this._pickAndClickSpine.visible = false;
                this.resetBonusModeThingy();
            }
        });

        return tl;
    }

    public toggleVisibility(flag: boolean): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        let alphaValue: number = flag ? 1 : 0;

        tl.to([this, this._overlay], {
            alpha: alphaValue,
            duration: flag || RockBottom.model.isRestore ? 0 : 1,
            onComplete: () => {
                this.visible = flag;
                this._overlay.visible = flag;
                this.alpha = 1;
                this._overlay.alpha = 1;
            }
        });

        return tl;
    }

    public showWinCapMultipliers(gameData: IRockBottomGameData): void {
        const winCapMult: number = gameData.capWinMultiplier,
            playerChosenIndex: number = parseInt((gameData.playerInteraction.selectedIndex).toString());

        this._multSeqArray.splice(this._multSeqArray.indexOf(winCapMult), 1);

        let randomNum: number;

        if (gameData.numberOfFreespinsPlayed) {
            randomNum = (gameData.numberOfFreespinsPlayed) % 10;
        } else {
            randomNum = ((winCapMult * playerChosenIndex) + (winCapMult + playerChosenIndex)) % 10
        }

        for (let i: number = 0; i < this._multipliers.length; i++) {
            if (i === playerChosenIndex) {
                this._multipliers[playerChosenIndex].text = winCapMult.toString() + this._multPostfixStr;
            } else {
                let idxToSelect: number = i;
                if (i > playerChosenIndex) {
                    idxToSelect--;
                }

                this._multipliers[i].text = this._multSeqArray[this._seqMap[randomNum][idxToSelect]].toString() + this._multPostfixStr;
            }
            this._multipliers[i].visible = true;
        }
    }

    public playToastAnim(symName: string): gsap.core.Timeline {
        return this._pickAndClickSpine.play({
            name: "Toast_" + symName,
            onStart: () => {
                if (!RockBottom.apiPlugin.isReplay) {
                    gsap.to(this, {
                        duration: 1,
                        onComplete: () => {
                            if (this._pickCallback != undefined) {
                                this._pickCallback(RockBottomGameConfig.MID_SYMS.indexOf(symName));
                                this._pickCallback = undefined;

                            } else {
                                throw new Error("No pickCallback set");
                            }
                        }
                    });
                }
                RockBottomSound.soundPlayer.stopTrack(RockBottomSound.SOFT_WIN_CAP_PICK_CLICK);
                RockBottomSound.soundPlayer.stopTrack(RockBottomSound.WIN_CAP_HOVER_LOOP);
                RockBottomSound.soundPlayer.playTrack({name: RockBottomSound.WIN_CAP_TOAST});
            },
            onComplete: () => {
                if (!RockBottom.apiPlugin.isReplay) {
                    this.initMultSeqArray();
                }
            }
        });
    }

    private resetBonusModeThingy(): void {
        if (RockBottom.inBonusGame) {
            RockBottom.keypadPlugin.setZeroBetSpinCounter(-1);
            RockBottom.freespinOutro.close();
        }
    }

    private init(): void {
        this._layer = RockBottomLayers.getLayer(Layers.SOFT_WIN_CAP_PICK);
        this.initMultSeqArray();
        this.createOverlay();
        this.createPickIntro();
        this.createPickAndClick();
        this.createSoftCapMultipliers();
        this.createButtons();
        this.toggleVisibility(false);
        this._layer?.addChild(this);
    }

    private createOverlay(): void {
        this._overlay = new PIXI.Graphics();
        this._overlay.visible = false;
        this._down_overlay = new PIXI.Graphics();
        this._down_overlay.name = "door_bottom_overlay";
        this._down_overlay.visible = false;
        this.setOverlayProps();
        this.addChild(this._overlay);
    }

    private setOverlayProps(): void {
        const bounds: ScreenBounds = NolimitApplication.screenBounds;
        this._overlay.clear();
        this._overlay.beginFill(0x000000);
        this._overlay.drawRect(bounds.left, bounds.top, bounds.width, bounds.height);
        this._overlay.endFill();
        this._down_overlay.clear();
        this._down_overlay.beginFill(0x000000);
        this._down_overlay.drawRect(bounds.left, bounds.center + 350, bounds.width, bounds.height / 2);
        this._down_overlay.endFill();
    }

    private onResize(): void {
        this.setOverlayProps();
    }

    private createPickIntro(): void {
        this._pickIntroSpine = this.createSpine("softCap");
        this.addChild(this._pickIntroSpine, this._down_overlay);
    }

    private createPickAndClick(): void {
        this._pickAndClickSpine = this.createSpine("softWinCapChoose");
        this.addChild(this._pickAndClickSpine);
    }

    private createSoftCapMultipliers(): void {
        for (let i: number = 0; i < RockBottomGameConfig.MID_SYMS.length; i++) {
            const text: PIXI.BitmapText = new PIXI.BitmapText("", {
                fontName: RockBottomGameAssets.BITMAP_FONT_WIN_COUNT_UP,
                fontSize: 9,
                letterSpacing: -15
            });
            text.skew.set(0.2, 0);
            text.alpha = 0.5;

            if (i === 0) {
                text.position.set(90, 460);
            } else if (i === 1) {
                text.position.set(230, 430);
            } else if (i === 2) {
                text.position.set(360, 430);
            } else if (i === 3) {
                text.position.set(500, 430);
            } else {
                text.position.set(640, 460);
                text.skew.set(0);
            }

            text.visible = false;
            this._multipliers.push(text);
            this.addChild(text);
        }
    }

    private createButtons(): void {
        for (let i: number = 0; i < RockBottomGameConfig.MID_SYMS.length; i++) {
            const symName: string = RockBottomGameConfig.MID_SYMS[i],
                mSymBtn: RockBottomPickButton = new RockBottomPickButton(symName, () => this.buttonClick(mSymBtn));

            mSymBtn.enable(false);
            mSymBtn.visible = false;
            this.adjustButtons(mSymBtn, i);
            this.addChild(mSymBtn);
        }
        this.addChild(this);
    }

    private createSpine(spineAnim: string, isVisible: boolean = false): SpinePlayer {
        const spineObj: SpinePlayer = new SpinePlayer(spineAnim);
        spineObj.position.set(360);
        spineObj.visible = isVisible;
        return spineObj;
    }

    private zoomInEffect(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.to(this._down_overlay, 0.3, {
            alpha: 0,
            ease: Linear.easeOut
        });
        tl.to(this._pickIntroSpine.scale, 0.7, {
            x: 1.9,
            y: 1.9,
            ease: Linear.easeOut
        });
        tl.to(this._pickIntroSpine, {
            alpha: 0,
            duration: 0.3,
            onComplete: () => {
                this._down_overlay.visible = false;
                this._pickIntroSpine.stop();
                this._pickIntroSpine.visible = false;
            }
        });

        return tl;
    }

    private buttonClick(button: RockBottomPickButton): void {
        this.enablePickButtons(false);
        this.playToastAnim(button.name);
    }

    private initMultSeqArray(): void {
        this._multSeqArray = [2, 3, 5, 7, 10];
        for (let i: number = 0; i < this._multipliers.length; i++) {
            this._multipliers[i].text = "";
            this._multipliers[i].visible = false;
            this._multipliers[i].alpha = 0.5;
        }
    }

    private enablePickButtons(enable: boolean): void {
        for (let i: number = 0; i < this.children.length; i++) {
            const pickBtn: DisplayObject = this.children[i];
            if (pickBtn instanceof RockBottomPickButton) {
                pickBtn.enable(enable);
                pickBtn.visible = true;
            }
        }
    }

    private adjustButtons(pickBtn: RockBottomPickButton, index: number): void {
        if (index === 0) {
            pickBtn.position.set(130, 550);
        } else if (index === 1) {
            pickBtn.position.set(215, 490);
        } else if (index === 2) {
            pickBtn.position.set(335, 490);
        } else if (index === 3) {
            pickBtn.position.set(475, 490);
        } else {
            pickBtn.position.set(620, 550);
        }
    }
}